export const teams = {
  jj1986: {
    owner: "JJ1986",
    coach: "Erik Spoelstra",
    players: [
      { name: "LeBron James", year: "2012-13" },
      { name: "Kobe Bryant", year: "2002-03" },
      { name: "Paul George", year: "2018-19" },
      { name: "Chauncey Billups", year: "2005-06" },
      { name: "Alonzo Mourning", year: "1999-2000" },
      { name: "Karl-Anthony Towns", year: "2017-18" },
      { name: "Metta World Peace", year: "2003-04" },
      { name: "Dan Majerle", year: "1992-93" },
      { name: "Buck Williams", year: "1982-83" },
      { name: "Eric Bledsoe", year: "2012-13" },
    ],
  },
  willardBaseball: {
    owner: "Willard Baseball",
    players: [
      { name: "Michael Jordan", year: "1987-88" },
      { name: "Dirk Nowitzki", year: "2006-07" },
      { name: "Draymond Green", year: "2015-16" },
      { name: "Gary Payton", year: "1995-96" },
      { name: "Vince Carter", year: "2000-01" },
      { name: "Allen Iverson", year: "2000-01" },
      { name: "Patrick Ewing", year: "1989-90" },
      { name: "Paul Millsap", year: "2015-16" },
      { name: "Jerry Sloan", year: "1966-67" },
      { name: "Isiah Thomas", year: "????-??" },
    ],
  },
  dca: {
    owner: "DCA",
    coach: "Bill Sharman",
    players: [
      { name: "Kareem", year: "1971-72" },
      { name: "Julius Erving", year: "1975-76" },
      { name: "Dwyane Wade", year: "2008-09" },
      { name: "Kevin Love", year: "2013-14" },
      { name: "John Stockton", year: "1994-95" },
      { name: "George Mikan", year: "1950-51" },
      { name: "Connie Hawkins", year: "1967-68" },
      { name: "Joakim Noah", year: "2013-14" },
      { name: "Detlef Schrempf", year: "1994-95" },
      { name: "Doug Christie", year: "2002-03" },
    ],
  },
  nj: {
    owner: "NJ",
    players: [
      { name: "Steph Curry", year: "2015-16" },
      { name: "Dwight Howard", year: "2010-11" },
      { name: "Reggie Miller", year: "1993-94" },
      { name: "George Gervin", year: "1979-80" },
      { name: "Kevin McHale", year: "1986-87" },
      { name: "Andre Iguodala", year: "2008-09" },
      { name: "Russell Westbrook", year: "2016-17" },
      { name: "Chris Bosh", year: "2013-14" },
      { name: "Luol Deng", year: "2010-11" },
      { name: "Dale Ellis", year: "1988-89" },
    ],
  },
  slivers: {
    owner: "Slivers",
    coach: "Pat Riley",
    players: [
      { name: "Shaq", year: "1999-00" },
      { name: "Steve Nash", year: "2006-07" },
      { name: "Karl Malone", year: "1992-93" },
      { name: "Grant Hill", year: "1996-97" },
      { name: "John Havlicek", year: "1971-72" },
      { name: "Derrick Rose", year: "2010-11" },
      { name: "Ben Wallace", year: "2001-02" },
      { name: "Blake Griffin", year: "2013-14" },
      { name: "Sam Jones", year: "1964-65" },
      { name: "Paul Arizin", year: "1951-52" },
    ],
  },
  dolfLucky: {
    owner: "Dolf Lucky",
    coach: "Flip Saunders",
    players: [
      { name: "Kevin Garnett", year: "2003-04" },
      { name: "James Harden", year: "2017-18" },
      { name: "Rudy Gobert", year: "2018-19" },
      { name: "Jason Kidd", year: "2002-03" },
      { name: "Peja Stojaković", year: "2003-04" },
      { name: "Bob Pettit", year: "1958-59" },
      { name: "Dikembe Mutombo", year: "1998-99" },
      { name: "Jeff Hornacek", year: "1995-96" },
      { name: "Chet Walker", year: "1971-72" },
      { name: "Doc Rivers", year: "1986-87" },
    ],
  },
  tShipman: {
    owner: "TShipman",
    coach: "Vinny Del Negro",
    players: [
      { name: "Magic Johnson", year: "1986-87" },
      { name: "Scottie Pippen", year: "1994-95" },
      { name: "Bill Walton", year: "1976-77" },
      { name: "Dennis Rodman", year: "1991-92" },
      { name: "Rasheed Wallace", year: "2001-02" },
      { name: "Terry Porter", year: "1990-91" },
      { name: "Khris Middleton", year: "2019-20" },
      { name: "Gilgamesh Humperdink", year: "2016-17" },
      { name: "Alvin Robertson", year: "1985-86" },
      { name: "Byron Scott", year: "1988-89" },
    ],
  },
  scottLange: {
    owner: "Scott Lange",
    coach: 'Mike "The Czar of the Telestrator" Fratello',
    players: [
      { name: "Hakeem Olajuwon", year: "1992-93" },
      { name: "Jerry West", year: "1965-66" },
      { name: "Klay Thompson", year: "2014-15" },
      { name: "Penny Hardaway", year: "1995-96" },
      { name: "Dolph Schayes", year: "1957-58" },
      { name: "Arvydas Sabonis", year: "1995-96" },
      { name: "Bobby Jones", year: "1976-77" },
      { name: "James Posey", year: "2003-04" },
      { name: "Danny Green", year: "2011-12" },
      { name: "Dominique Wilkins", year: "1992-93" },
    ],
  },
  wintersNight: {
    owner: "Winter's Night",
    coach: "Brad Stevens",
    players: [
      { name: "Kevin Durant", year: "2013-14" },
      { name: "Tracy McGrady", year: "2002-03" },
      { name: "Manu Ginobili", year: "2007-08" },
      { name: "Elgin Baylor", year: "1960-61" },
      { name: "Chris Webber", year: "1999-00" },
      { name: "Marc Gasol", year: "2012-2013" },
      { name: "Al Horford", year: "2017-18" },
      { name: "Nate McMillan", year: "1993-94" },
      { name: "Jayson Tatum", year: "2019-20" },
      { name: "Kyle Korver", year: "2014-2015" },
    ],
  },
  jtSports: {
    owner: "JTSports",
    players: [
      { name: "Larry Bird", year: "1985-86" },
      { name: "Anthony Davis", year: "2017-18" },
      { name: "Walt Frazier", year: "1969-70" },
      { name: "Nikola Jokić", year: "2018-19" },
      { name: "Sidney Moncrief", year: "1982-83" },
      { name: "Shane Battier", year: "2006-07" },
      { name: "Victor Oladipo", year: "2017-18" },
      { name: "Chris Mullin", year: "????-??" },
      { name: "Nate Thurmond ", year: "1966-67" },
      { name: "Elton Brand", year: "2005-06" },
    ],
  },
  hombre: {
    owner: "Hombre",
    coach: "Phil Jackson",
    players: [
      { name: "Wilt Chamberlain", year: "1963-64" },
      { name: "Chris Paul", year: "2008-09" },
      { name: "Charles Barkley", year: "1987-88" },
      { name: "Rick Barry", year: "1974-75" },
      { name: "Brandon Roy", year: "2008-09" },
      { name: "Clyde Drexler", year: "1991-92" },
      { name: "Lamar Odom", year: "2010-11" },
      { name: "Pau Gasol", year: "2010-11" },
      { name: "Kyle Lowry", year: "2015-16" },
      { name: "Joel Embiid", year: "2019-2020" },
    ],
  },
  stiggles: {
    owner: "STIGGLES",
    coach: "Steve Kerr",
    players: [
      { name: "Giannis", year: "2018-19" },
      { name: "Kawhi Leonard", year: "2015-16" },
      { name: "Andrei Kirilenko", year: "2003-04" },
      { name: "Yao Ming", year: "2008-09" },
      { name: "Shawn Kemp", year: "1993-94" },
      { name: "Damian Lillard", year: "2019-20" },
      { name: "Kyrie Irving", year: "2018-2019" },
      { name: "Brent Barry", year: "2001-02" },
      { name: "Gerald Wallace", year: "2005-06" },
      { name: "Drazen Petrovic", year: "1992-93" },
    ],
  },
  baseballObscura: {
    owner: "BaseballObscura",
    coach: "Bill Russell / Billy Cunningham",
    players: [
      { name: "Bill Russell", year: "1963-64" },
      { name: "Tim Duncan", year: "2001-02" },
      { name: "Luka Dončić", year: "2019-20" },
      { name: "Ray Allen", year: "2000-01" },
      { name: "Bernard King", year: "1983-84" },
      { name: "Shawn Marion", year: "2002-03" },
      { name: "Amar'e Stoudamire", year: "2007-08" },
      { name: "Mookie Blaylock", year: "1996-97" },
      { name: "Kangaroo Kid", year: "1972-73" },
      { name: "Joe Dumars", year: "1989-90" },
    ],
  },
  harlond: {
    owner: "Harlond",
    coach: "Gregg Popovich",
    players: [
      { name: "David Robinson", year: "1994-95" },
      { name: "Oscar Robertson", year: "1963-64" },
      { name: "Paul Pierce", year: "2001-02" },
      { name: "Jimmy Butler", year: "2016-17" },
      { name: "Ben Simmons", year: "2019-20" },
      { name: "Moses Malone", year: "1982-83" },
      { name: "Eddie Jones", year: "1999-2000" },
      { name: "Donyell Marshall", year: "2003-2004" },
      { name: "Sam Cassell", year: "2003-04" },
      { name: "Horace Grant", year: "1991-92" },
    ],
  },
};
